import { render, staticRenderFns } from "./costreport.vue?vue&type=template&id=3b22c485&"
import script from "./costreport.vue?vue&type=script&lang=js&"
export * from "./costreport.vue?vue&type=script&lang=js&"
import style0 from "./costreport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports